import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '~/literals';

import { ErrorResponse, ToursSearchState } from '~/types';
import { Tour } from '~/types/tours';

export interface TourSearchParams {
  latitude: number,
  longitude: number,
  radius: number,
}

export const toursSearchState: ToursSearchState = {
  tours: [],
  alertMessage: '',
  pageStatus: STATUS.IDLE,
};

export const toursSlice = createSlice({
  name: 'flightSearch',
  initialState: toursSearchState,
  reducers: {
    getTours: (draft, _: PayloadAction<TourSearchParams>) => {
      draft.alertMessage = '';
      draft.pageStatus = STATUS.RUNNING;
    },
    getToursSuccess: (draft, { payload }: PayloadAction<Tour[]>) => {
      draft.tours = payload;
      draft.pageStatus = STATUS.SUCCESS;
    },
    getToursFailure: (draft, { payload }: PayloadAction<ErrorResponse>) => {
      draft.alertMessage = payload.errorMessage || 'Could not load tours.';
      draft.pageStatus = STATUS.ERROR;
    }
  },
});

export const {
  getTours,
  getToursSuccess,
  getToursFailure
} = toursSlice.actions;

export default toursSlice.reducer;
